<template>
  <a
    class="carousel-cell cursor-pointer relative"
    @click="setLesson"
  >
    <div class="flex-col flex class-item">
      <img v-if="data.isOnline && onlineClassesLink !== ''" class="cameraIcon" src="@/assets/images/icons/camera.svg" />
      <span class="font-semibold">
        {{ date.format('DD.MM') }} ({{ date.format('dddd') }})
        <span v-if="data.isWorkshop" class="workshop-label">(warsztaty)</span>
      </span>
      <span>
       {{ startHour.format('HH:mm') }} - {{ finishHour.format('HH:mm') }}
      </span>
    </div>
  </a>
</template>

<script>
import { mapState } from 'vuex';
import moment from 'moment';

export default {
  name: 'ClassItem',

  props: {
    data: Object,
  },

  computed: {
    ...mapState('students', ['student']),

    date() {
      return moment(this.data.date);
    },

    onlineClassesLink() {
      return this.student.group.zoomUrl;
    },

    startHour() {
      return moment(this.data.startHour, 'HH:mm:ss');
    },

    finishHour() {
      return moment(this.data.finishHour, 'HH:mm:ss');
    },
  },

  methods: {
    setLesson() {
      this.$emit('menu-clicked');
      this.$store.commit('lessons/setLesson', this.data);
    },
  },
};
</script>

<style lang="scss" scoped>
.carousel-cell {
  @apply flex justify-start items-center mr-3 p-3 bg-white text-sm text-black-2 no-underline;
  row-gap: 2px;
  width: 144px;
  height: 58px;
  line-height: 16px;
  border: 1px solid #ec268f;
  border-radius: 4px;
  transition: .5s background, .3s color;
  @media screen and (min-width: 992px) {
    @apply px-6 py-3;
    width: 168px;
  }
  &:last-child {
    @apply mr-0;
  }
  &:hover {
    @apply bg-pink-dark-main text-white border-pink-dark-main;

    .workshop-label {
      @apply text-white;
    }
  }
}

.cameraIcon {
  @apply absolute;
  top: -6px;
  right: -6px;
  width: 22px;
  height: 22px;
  padding: 4px;
  border-radius: 50px;
  background-color: #00a7e9;
  @media screen and (min-width: 768px) {
    top: -5px;
    right: -5px;
  }
  @media screen and (min-width: 992px) {
    width: 28px;
    height: 28px;
  }
}

.class-item {
  gap: 6px;
}

.workshop-label {
  @apply text-grey-2;
  font-weight: normal;
  transition: .3s color;
}

.active-item {
  color: #fff !important;
  background: #ec268f !important;
  border-color: #ec268f !important;

  .workshop-label {
    @apply text-white;
  }

  &:hover {
    background: #bd1e72 !important;
    border-color: #bd1e72 !important;
  }
}
</style>
